import React, { useState, useEffect, useContext } from 'react'
import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import MUIGrid from '@material-ui/core/Grid'

const styles = theme => ({
})

const Grid = ({ theme, classes, size, items, renderItem, maxRowCount=-1, ...props }) => {
  
  let smUp = useMediaQuery(theme.breakpoints.up('sm'))
  let mdUp = useMediaQuery(theme.breakpoints.up('md'))
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'))
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'))
  
  let spacing
  let itemsPerRow
  
  if (size == 'large') {
    itemsPerRow = 1

    if (xlUp)
      spacing = 8
    else if (lgUp)
      spacing = 6
    else if (mdUp)
      spacing = 4
    else if (smUp)
      spacing = 3
    else
      spacing = 2
  }    
  else if (size == 'medium') {
    if (xlUp) {
      itemsPerRow = 4
      spacing = 3
    }
    else if (lgUp) {
      itemsPerRow = 4
      spacing = 3
    }
    else if (mdUp) {
      itemsPerRow = 3
      spacing = 3
    }
    else if (smUp) {
      itemsPerRow = 2
      spacing = 2
    }
    else{
      itemsPerRow = 1
      spacing = 2
    }
  }      
  else { // small
    if (xlUp) {
      itemsPerRow = 6
      spacing = 2
    }
    else if (lgUp) {
      itemsPerRow = 6
      spacing = 2
    }
    else if (mdUp) {
      itemsPerRow = 4
      spacing = 2
    }
    else if (smUp) {
      itemsPerRow = 3
      spacing = 2
    }
    else {
      itemsPerRow = 2
      spacing = 2
    }
  }
  
  let filteredItems = [...(items || [])]
  if (maxRowCount >= 0) {
    const maxItems = maxRowCount * itemsPerRow
    if (filteredItems.length > maxItems)
      filteredItems.splice(maxItems, filteredItems.length - maxItems)
  }
  
  return (
    <MUIGrid container justify='flex-start'
      spacing={spacing} {...props}
      >
      { filteredItems.map((item, index) => (
        <MUIGrid item xs={12/itemsPerRow}>
          { renderItem(item, index) }
        </MUIGrid>
      ))}
    </MUIGrid>
  )
}

export default withStyles(styles, { withTheme: true })(Grid)